import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getSkillsRequest: [],
  getSkillsSuccess: ['data'],
  getSkillsFailure: ['error'],
});

export const SkillsTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  skills: [],
  skillsError: {},
});

/* Reducers */

const getSkillsRequest = (state) =>
  state.merge({
    ...state,
    skillsError: {},
  });

const getSkillsSuccess = (state, { data }) =>
  state.merge({
    skills: data,
    skillsError: {},
  });

const getSkillsFailure = (state, { error }) =>
  state.merge({
    ...state,
    skillsError: { ...error },
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SKILLS_REQUEST]: getSkillsRequest,
  [Types.GET_SKILLS_SUCCESS]: getSkillsSuccess,
  [Types.GET_SKILLS_FAILURE]: getSkillsFailure,
});
